export default __webpack_public_path__ + "static/media/default-location.61a75e4e.svg";